import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import { ToastContainer } from 'react-toastify';
import { CartProvider } from './context/cartContext.jsx';
import { HomepageProvider } from './context/homepageContext.jsx';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://1c09802bb23e2d0d9980218276b9d59a@o4509282928623617.ingest.de.sentry.io/4509282932359248',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    'app.svisit.ch',
    /^https:\/\/app\.svisit\.ch/,
    /^https:\/\/yourserver\.io\/api/,
  ],
});

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <>
    <HomepageProvider>
      <CartProvider>
        <App />
        <ToastContainer
          position="top-right"
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
        />
      </CartProvider>
    </HomepageProvider>
  </>
  // </React.StrictMode>
);
